"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SQRT12Docs = void 0;
var SQRT12Docs = exports.SQRT12Docs = {
  name: 'SQRT1_2',
  category: 'Constants',
  syntax: ['SQRT1_2'],
  description: 'Returns the square root of 1/2, approximately equal to 0.707',
  examples: ['SQRT1_2', 'sqrt(1/2)'],
  seealso: []
};